import { render, staticRenderFns } from "./list5.vue?vue&type=template&id=399b3e39&"
import script from "./list5.vue?vue&type=script&lang=js&"
export * from "./list5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports